import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { InputDatepicker } from 'src/app/shared/components/datepicker_v2/interfaces/input-datepicker';

@Component({
  selector: 'app-credentials',
  templateUrl: './credentials.component.html',
  styleUrls: ['./credentials.component.css']
})
export class CredentialsComponent implements OnInit {
  showCredentials: boolean = true;
  @Input() formGroupName!: string;
  @Input() submitted!: boolean;
  @Input() isEdit!: boolean;
  @Input('isThirdPartyComp') isThirdPartyComp: boolean = false;
  credentialsForm!: FormGroup;
  isDisabled: boolean = true;
  credentialsData: any;
  clientSecretMasked!: string;
  showButtonLoader: boolean = false;
  feild_startDate = {
    type: 'datetimepicker',
    inputClassName: ["form-control date-input"],
    selectedDateClassName: ['selectedDate', 'form-control'],
    arrowClassName: ['arrow'],
    dayClassName: ['dd'],
    todayClassName: ['now'],
    monthClassName: ['mtn'],
    monthListClassName: ['monthlist'],
    yearBtnHeadClassName: ['YY'],
    yearListClassName: ['yList'],
    range: true,
    locale: 'en-IN',
    placeholder: 'DD/MM/YYYY',
    options: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
    classname: ['form-control'],
  };
  validity_date_v2:InputDatepicker={
    type: 'datepicker_v2',
    name: 'Validity',
    range: true,
    locale: 'en-IN',
    required : true,
    inputClassName:'form-control date-input',
    selectedDateClassName: 'selectedDate',
    arrowClassName: 'arrow',
    dayClassName: 'dd',
    todayClassName: 'now',
    monthClassName: 'mtn',
    datepickerHeaderClass:'', //classes for the active date div
    headerButtonClass:'', // classes for month-year buttons
    yearClassName:'',
    options: {year: 'numeric', month: '2-digit', day: '2-digit'},
    classname: '',
    timer:false,
    disabled:false, // disables the datepicker
    seperator:' to ', // seperator b/w dates
    startDatePlaceHolder:'DD/MM/YYYY',
    dateFormat:'DD/MM/YYYY' ,// dd-mm-yyyy | dd/mm/yyyy
    dateSeperator:'/', // seperator b/w dd,mm,yyyy
  }
  copyText: string = 'copy';
  isLoader: boolean = false;
  constructor(
    private rootFormGroup: FormGroupDirective,
    private apiService: ProvPayerApiService,
    private toasterandloader : ToasterService
  ) { }

  ngOnInit(): void {
    this.credentialsForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.maskSecret();
    this.credentialsForm?.controls?.['url'].disable();
    this.credentialsForm?.controls?.['clientSecret'].disable();
    this.credentialsForm?.controls?.['clientId'].disable();
    this.credentialsForm?.controls?.['date'].disable();
  }
  maskSecret() {
    setTimeout(() => {
      this.credentialsData = this.credentialsForm?.value;
      let first = this.credentialsData?.clientSecret?.slice(0, 2);
      let last = this.credentialsData?.clientSecret?.substr(this.credentialsData?.clientSecret.length - 2);
      this.credentialsData.clientSecretMasked = first + '*********************' + last;
    }, 1000);
  }
  copyMessage(item?: any) {
    this.copyText = 'copied'
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = item;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
  regenerateClientSecret() {
    this.showButtonLoader = true;
    this.copyText = 'copy'
    this.apiService.regenerateClientSecret(this.credentialsData?.clientId)
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.credentialsData.clientSecret = response?.data?.client_secret;
            let first = this.credentialsData?.clientSecret?.slice(0, 2);
            let last = this.credentialsData?.clientSecret?.substr(this.credentialsData?.clientSecret.length - 2);
            this.credentialsData.clientSecretMasked = first + '*******************' + last;
            this.showButtonLoader = false;
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: 'Client Secret Successfully Regenerated'
            })
          }
        },
        error: (error: any) => {
          this.showButtonLoader = false;
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: "Error Occurred"
        })
        }

      });

  }
}
